module.exports = __webpack_public_path__ + "static/media/car5.dc231135.png";